// Emerald/Header "Spade logo" (Figma 393:121): the brand spade, 20×22, filled
// with accent-base. Decorative; the brand text beside it names the app.
const SPADE_PATH =
  'M10 0C7.91667 4.125 1.25 8.25 1.25 13.2917C1.25 18.3333 7.08333 19.7083 9.58333 15.5833C9.16667 18.7917 7.5 20.625 5.83333 21.5417H14.1667C12.5 20.625 10.8333 18.7917 10.4167 15.5833C12.9167 19.7083 18.75 18.3333 18.75 13.2917C18.75 8.25 12.0833 4.125 10 0Z';

export function SpadeLogo() {
  return (
    <svg
      data-testid="spade-logo"
      aria-hidden="true"
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      style={{ flexShrink: 0 }}
    >
      <path d={SPADE_PATH} fill="var(--spades-accent-base)" />
    </svg>
  );
}

export default SpadeLogo;
